
















































































































































import { Component } from "vue-property-decorator";
import { Collection, ProductLineName } from "@/models/products/collection";
import ProductService from "@/services/product_service";
import ConfigFileService from "@/services/config_file_service";
import { ProductType } from "@/models/products/product";
import { UmbrellaModel, UmbrellaType } from "@/models/products/umbrella";
import { mixins } from "vue-class-component";
import {
  BaseStore,
  LayoutStore,
  ShapeStore,
  CanopyStore,
  FrameStore,
  SurchargeStore
} from "@/mixins/store";
import { ConfigCreator } from "@/mixins/configurator";
import { APIError, NotFoundError, ViewerError } from "@/services/error_service";
import { ConfigFile } from "@/models/configurator/config_file";
import { Auth } from "@/mixins/auth";
import { StockMixin } from "@/mixins/stock";
import AuthService from "@/services/auth_service";
import AccordionSection from "@/components/designer/reusable/AccordionSection.vue";
import {
  productLineContent,
  umbrellaTypeContent,
  ProductLineContent
} from "@/models/products/collection_content";
import Header from "@/components/designer/header/Header.vue";
import ConfigCodeModal from "@/components/designer/reusable/modal/ConfigCodeModal.vue";
import ComingSoonModal from "@/components/designer/reusable/modal/ComingSoonModal.vue";
import { ClearAllPresetDesigns } from "@/mixins/helpers";

@Component({
  components: {
    AccordionSection,
    Header,
    ConfigCodeModal,
    ComingSoonModal
  }
})
export default class CollectionMenu extends mixins(
  BaseStore,
  LayoutStore,
  ShapeStore,
  CanopyStore,
  FrameStore,
  ConfigCreator,
  Auth,
  StockMixin,
  ClearAllPresetDesigns,
  SurchargeStore
) {
  /* The design frame the card geometry is taken from: a 1440px page, 40px of
     container padding either side, cards split evenly across the row. */
  private static readonly DESIGN_ROW_WIDTH = 1360;
  private static readonly DESIGN_GAP = 20;
  private static readonly DESIGN_PANEL_HEIGHT = 360;

  protected selection = {} as Collection;
  protected type: UmbrellaType = UmbrellaType.Market;
  protected umbrellaType = UmbrellaType;
  protected umbrellas: Collection[] = [];
  protected productService = new ProductService();
  protected configFileService = new ConfigFileService();
  protected authService = new AuthService();
  protected ProductLineName = ProductLineName;
  protected showConfigModal = false;
  protected showComingSoonModal = false;
  protected comingSoonCollectionName = "";
  protected productSelectionInProgress = false;
  async created(): Promise<void> {
    if (this.$route.query.handle) {
      const loader = this.$loading.show({ opacity: 1 });
      this.umbrellas = await this.getProductLines();
      this.selection = this.umbrellas.find(u => {
        return (
          u.handle === (this.$route.query.handle as string).replaceAll("-", "_")
        );
      })!;
      if (!this.selection) {
        ViewerError.redirect("Invalid handle.");
      } else {
        loader.hide();
        await this.start();
      }
    } else if (this.$route.query.design) {
      const fileShareId = this.$route.query.design as string;
      if (this.$route.query.edit) {
        const loader = this.$loading.show(
          { opacity: 1 },
          {
            before: this.$createElement("h1", "Loading...")
          }
        );
        if (this.$route.query.design !== "redirect") {
          const configFile = await this.fetchSharedConfigFile(fileShareId);
          await this.transformConfigFileAndSaveToStore(configFile);
        }
        this.clearAllPresetDesigns();
        this.$router.replace("/designer");
        loader.hide();
      } else {
        this.$router.push("/view?design=" + fileShareId);
      }
    } else {
      this.umbrellas = await this.getProductLines();
      this.getDefaultSelection();
      // The Configurator absolutely needs the store to be populated before it can be used.
      // If not populated already, we set it with the default umbrella config here.
      if (!this.collection || !this.umbrellaModel) {
        console.log("Populating store with default umbrella config");
        console.log("this.collection", this.collection);
        console.log("this.umbrellaModel", this.umbrellaModel);
        await this.populateStore();
      }
      await this.checkAuth();
    }
  }

  protected async fetchSharedConfigFile(shareId: string): Promise<ConfigFile> {
    let file = {} as ConfigFile;
    try {
      const res = await this.configFileService.getShareFile(shareId);
      file = res;
    } catch (err) {
      if (err instanceof NotFoundError) {
        NotFoundError.popup(err.message, err.statusCode);
      } else {
        APIError.popup(err.message, err.statusCode);
      }
    }
    return file;
  }

  /** Fix for weird vue transition/animation issues */
  protected beforeLeave(el: any): void {
    const { marginLeft, marginTop, width, height } = window.getComputedStyle(
      el
    );
    el.style.left = `${el.offsetLeft - parseFloat(marginLeft)}px`;
    el.style.top = `${el.offsetTop - parseFloat(marginTop)}px`;
    el.style.width = width;
    el.style.height = height;
  }

  protected async getProductLines(): Promise<Collection[]> {
    let umbrellas: Collection[] = [];
    try {
      const res = await this.productService.getProducts({
        category: ProductType.Umbrella,
        sort: "productline"
      });
      umbrellas = res;
    } catch (err) {
      if (err instanceof NotFoundError) {
        NotFoundError.popup(err.message, err.statusCode);
      } else {
        APIError.popup(err.message, err.statusCode);
      }
    }
    return umbrellas;
  }

  protected async start(): Promise<void> {
    try {
      console.log("this.selection:", this.selection);
      const configFile = this.getDefaultConfigFile();
      await this.transformConfigFileAndSaveToStore(configFile);
      console.log("configFile:", configFile);
      console.log("this.collection - start:", this.collection);
      console.log("this.umbrellaModel - start:", this.umbrellaModel);
      await this.$router.push("/designer");
    } catch (err) {
      APIError.redirect(
        "There was an error loading the umbrella configuration. The selected umbrella and/or its parts or fabric may no longer be available. If you believe this is an error, please contact Frankford Umbrellas directly for more information at info@frankfordumbrellas.com."
      );
    }
  }

  protected async populateStore(): Promise<void> {
    try {
      const configFile = this.getDefaultConfigFile();
      await this.transformConfigFileAndSaveToStore(configFile);
      console.log("configFile:", configFile);
      console.log("this.collection - populateStore:", this.collection);
      console.log("this.umbrellaModel - populateStore:", this.umbrellaModel);
    } catch (err) {
      console.error("Error populating store", err);
    }
  }

  protected getDefaultConfigFile(): ConfigFile {
    if (this.selection.config_file) {
      const file: any = this.selection.config_file as any;
      return file[0]; //TODO, THIS SHOULDNT BE AN ARRAY
    } else {
      throw new ViewerError(
        "No default configuration for this umbrella found."
      );
    }
  }

  protected async selectProduct(umbrella: Collection): Promise<void> {
    if (this.productSelectionInProgress) return;
    if (this.comingSoonHandles.includes(umbrella.handle)) {
      this.comingSoonCollectionName = umbrella.display_name || "";
      this.showComingSoonModal = true;
      return;
    }
    this.productSelectionInProgress = true;
    this.selection = umbrella;
    // FUMBSD-761: pick up a changed surcharge; not awaited so it never delays the designer
    if (this.isLoggedIn) this.refreshSurcharge(true);
    await this.start();
  }

  protected get comingSoonHandles(): string[] {
    const raw = process.env.VUE_APP_COMING_SOON_COLLECTION_HANDLES;
    if (!raw) return [];
    return raw
      .split(",")
      .map((h: string) => h.trim())
      .filter((h: string) => h.length > 0);
  }

  protected openConfigModal(): void {
    this.showConfigModal = true;
  }

  protected selectTab(type: UmbrellaType): void {
    this.type = type;
    this.getDefaultSelection();
  }

  protected getDefaultSelection(): void {
    const defaultSelection = this.umbrellas.filter(
      umbrella => umbrella.umbrella_type === this.type
    );
    if (this.type === UmbrellaType.Market) {
      this.selection = defaultSelection.find(e => e.handle === "greenwich")!;
    } else if (this.type === UmbrellaType.Cantilever) {
      this.selection = defaultSelection.find(e => e.handle === "eclipse")!;
    } else if (this.type === UmbrellaType.Giant) {
      this.selection = defaultSelection.find(
        e => e.handle === "monterey_g_series"
      )!;
    }
    // else if (this.type === UmbrellaType.Patio) {
    //   this.selection = defaultSelection.find((e) => e.handle === "laurel")!;
    // } else if (this.type === UmbrellaType.Beach) {
    //   this.selection = defaultSelection.find((e) => e.handle === "avalon")!;
    // }
  }

  protected get umbrellasFiltered(): Collection[] {
    return this.umbrellas.filter(
      umbrella =>
        umbrella.umbrella_type === this.type && umbrella.handle !== "shade_star"
    );
  }

  /** Product lines belonging to an umbrella type, in API sort order. */
  protected collectionsOfType(type: UmbrellaType): Collection[] {
    return this.umbrellas.filter(
      umbrella =>
        umbrella.umbrella_type === type && umbrella.handle !== "shade_star"
    );
  }

  /**
   * Editorial content for a product line, or undefined when the handle has no
   * entry yet. Callers must treat undefined as "render the card without a
   * description and without the hover overlay".
   */
  protected cardContent(umbrella: Collection): ProductLineContent | undefined {
    return productLineContent[umbrella.handle];
  }

  protected cardTitle(umbrella: Collection): string {
    return this.cardContent(umbrella)?.title || umbrella.display_name || "";
  }

  protected cardDescription(umbrella: Collection): string {
    return this.cardContent(umbrella)?.description || "";
  }

  /**
   * Heading above the hover overlay's bullets. Derived from the card title so
   * the product name is not duplicated in the content file — the leading
   * article is dropped because the sentence supplies its own.
   */
  protected tooltipHeading(umbrella: Collection): string {
    const name = this.cardTitle(umbrella).replace(/^The\s+/i, "");
    return `Choose the ${name} when you want:`;
  }

  /** True when the design file supplies a studio render for this product line. */
  protected hasStudioImage(umbrella: Collection): boolean {
    return !!this.cardContent(umbrella)?.studioImage;
  }

  /**
   * Which of the three framings the resting-state image gets: the design file's
   * hand-placed crop, its natural cover framing, or — for a product line with no
   * design-file entry — the API render contained on its white backdrop.
   */
  protected studioImageClass(umbrella: Collection): string {
    if (!this.hasStudioImage(umbrella)) return "product-card__image--contain";
    return this.cardContent(umbrella)?.studioCrop
      ? "product-card__image--cropped"
      : "product-card__image--fill";
  }

  /**
   * The design's placement for one render, handed to the stylesheet as custom
   * properties. They are custom properties rather than plain `width`/`left`/
   * `top` so the narrow-screen media query can still take the render back to a
   * plain `cover` fit — an inline `width` would outrank any rule that tried.
   */
  protected studioCropStyle(umbrella: Collection): Record<string, string> {
    const crop = this.cardContent(umbrella)?.studioCrop;
    if (!crop) return {};
    return {
      "--crop-width": `${crop.width}%`,
      "--crop-left": `${crop.left}%`,
      "--crop-top": `${crop.top}%`
    };
  }

  /**
   * The media panel's aspect ratio, as the `padding-top` percentage that holds
   * it (see `.product-card__media`).
   *
   * The design lays every row out at a 1440px frame: a 1360px content width, a
   * 20px gap and a panel 360px tall, with the cards splitting the row evenly.
   * So a row's panel ratio falls out of how many cards are in it — two cards
   * are 670px wide against 360px, three are 440px, four are 325px. Deriving it
   * per row rather than hard-coding one height is what lets a card keep the
   * design's framing as it narrows: the panel and the render inside it scale
   * together, instead of the render staying put while the card closes in on it.
   */
  protected panelAspect(type: UmbrellaType): Record<string, string> {
    const count = this.collectionsOfType(type).length;
    if (!count) return {};
    const cardWidth =
      (CollectionMenu.DESIGN_ROW_WIDTH -
        CollectionMenu.DESIGN_GAP * (count - 1)) /
      count;
    const ratio = (CollectionMenu.DESIGN_PANEL_HEIGHT / cardWidth) * 100;
    return { "--panel-aspect": `${ratio.toFixed(3)}%` };
  }

  /**
   * Hover photo framing. Only the lines whose subject would otherwise sit
   * behind the overlay carry a crop; everyone else keeps the plain `cover`
   * framing set in the stylesheet.
   */
  protected lifestyleCropStyle(umbrella: Collection): Record<string, string> {
    const crop = this.cardContent(umbrella)?.lifestyleCrop;
    if (!crop) return {};
    return { height: `${crop.height}%`, top: `${crop.top}%` };
  }

  /**
   * Resting-state image: the design file's render when we have one, otherwise
   * the product API's own image so unmapped product lines still show something.
   */
  protected studioImage(umbrella: Collection): string {
    return this.cardContent(umbrella)?.studioImage || this.getImg(umbrella);
  }

  protected typeLabel(type: UmbrellaType): string {
    return umbrellaTypeContent[type]?.label || type;
  }

  protected typeDescription(type: UmbrellaType): string {
    return umbrellaTypeContent[type]?.description || "";
  }

  protected getImg(umbrella: Collection): string {
    let img = "";

    img = umbrella.image as string;

    return img + "?width=800";
  }
}
